import { ApolloQueryResult, gql } from '@apollo/client'

import { client } from '../client'
import { Transportation } from '../../types/transportation';


const GET_TRANSPORTATION_QUERY = gql`
query GetTransportation($id: Int!, $qtirLanguageId: Int!) {
  getTransportation(id: $id, qtirLanguageId: $qtirLanguageId) {
    transportation {
      announcementId
      companyName
      driverName
      driverIdNo
      driverIdType
      phoneNumber
      registrationNumber
      scheduleFrom
      scheduleTo
      trailerRegistrationNumber
      transportationType
      transportationTypeId
    }
  }
}
`

interface GetTransportationVars {
  id: number,
  qtirLanguageId: number,
}

interface GetTransportationData {
  getTransportation: {
    transportation: Transportation
  }
}


export const getTransportation = async (args: GetTransportationVars): Promise<ApolloQueryResult<GetTransportationData>> => {
  return await client.query<GetTransportationData, GetTransportationVars>({ fetchPolicy: 'network-only', query: GET_TRANSPORTATION_QUERY, variables: args })
}
